import OrdersTable from "./OrdersTable"

export default  OrdersTable;



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/OrdersTable/index.js